import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { Cliente } from "../../login/cliente_login";
import { SegurosContratadosEntity } from "../datosGenerales/entities/seguros_contratados_entity";
import { VehiculoEntity } from "../datosGenerales/entities/vehiculo_entity";
import { ViviendaEntity } from "../datosGenerales/entities/vivienda_entity";
import { AsistenciaMedicaEntity } from "../datosGenerales/entities/asistencia_medica_entity";
import { CoberturaBienEntity } from "../datosGenerales/entities/coberturas_entity";
import { SessionStorageService } from "ngx-webstorage";

declare var jQuery: any;

@Injectable()
export class SegurosContratadosService {
    usuario: ClienteLogin;
    userMasivos: Cliente;
    private url="infoClienteIndividual";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

      consultaSegurosContratados(): Observable<SegurosContratadosEntity> {
        this.userMasivos = jQuery.parseJSON(this.sessionStorageService.retrieve("usermasivos"));
        let body = JSON.stringify(this.userMasivos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarSeguros", body, options).map(this.extractData)
            .catch(this.handleError);                 
    }

    getCertificadoVehiculos(parametros: VehiculoEntity ): Observable<any> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/certificadoVehiculo/", body, options)
            .map(response => response).catch(this.handleError);

    }
     getCertificadoVivienda(parametros: ViviendaEntity ): Observable<any> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/certificadoVivienda/", body, options)
            .map(response => response).catch(this.handleError);

    }

    insertarDependientesInclusion(detalleAsistenciaMedica): Observable<boolean> {
        let body = JSON.stringify(detalleAsistenciaMedica);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/insertarInclusionDependientes", body, options).map(this.extractData)
            .catch(this.handleError);
    }


    traerCoberturas(asistenciaMedicaEntity: AsistenciaMedicaEntity): Observable<CoberturaBienEntity[]> {        
        let body = JSON.stringify(asistenciaMedicaEntity);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarCoberturasBien", body, options).map(this.extractData)
            .catch(this.handleError);   
    }        
  
     
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/segurosContratados/seguros-contratados.service.ts